import { AssistantItems } from '@repo/shared/dtos/assistant'
import { useT } from '@repo/ui/hooks'
import { memo } from 'react'

import { AssistantMessage } from '@/components/assistant/messages/AssistantMessage'

export const TipsHandler = memo(function ({ tips }: { tips: AssistantItems['tip'][] }) {
  const { t } = useT({ keyPrefix: 'assistant' })

  return (
    <AssistantMessage className="flex flex-col gap-1 leading-snug" traceUrl={tips[0]?.traceUrl}>
      <span className="text-xl font-bold">{t('tips')}</span>
      <div className="flex flex-col gap-2">
        {tips.map((tip) => (
          <div key={tip.id} className="flex flex-col gap-px">
            <span className="text-lg font-semibold">{tip.title}</span>
            <span>{tip.content}</span>
          </div>
        ))}
      </div>
    </AssistantMessage>
  )
})
